import type { ContentLang } from '../editorSlice'

interface CourseLangFields {
  name?: string | null
  nameEn?: string | null
  description?: string | null
  descriptionEn?: string | null
}

const filled = (v?: string | null): boolean => Boolean(v?.trim())

/** Заполнен ли языковой слот курса. Считаем название ИЛИ описание — так же, как
 *  считал приватный предикат шапки редактора. Баннер НЕ участвует: он один на оба
 *  языка (поля `bannerEn` в контракте нет), и точка горела бы у обоих языков разом,
 *  потеряв смысл. Единственный источник признака — его читают и шапка, и диалог. */
export const hasContentFor = (lang: ContentLang, course: CourseLangFields): boolean =>
  lang === 'ru'
    ? filled(course.name) || filled(course.description)
    : filled(course.nameEn) || filled(course.descriptionEn)

/**
 * Заполнен ли слот ЦЕЛИКОМ — и название, и описание. Отдельный предикат, а не
 * ужесточение `hasContentFor`: тот отвечает на другой вопрос, «заведён ли язык
 * вообще», и по нему меню шапки решает, показывать ли язык в списке. Сделай его
 * строже — и курс с одним лишь переведённым названием пропал бы из меню.
 *
 * Нужен точке-индикатору: подпись «EN не заполнен» под каждым полем снял
 * заказчик (п.14), сказав, что её работу выполняет точка. Работу она выполняет,
 * только если считает ОБА поля — иначе переведённое название гасит сигнал о
 * непереведённом описании, за которое бэк всё равно возьмёт деньги.
 */
export const isLangSlotComplete = (lang: ContentLang, course: CourseLangFields): boolean =>
  lang === 'ru'
    ? filled(course.name) && filled(course.description)
    : filled(course.nameEn) && filled(course.descriptionEn)
